import * as api from 'api'
import { getAuthToken } from './authManager'

const SESSION_KEY = 'bcn_session_id'

const ensureSessionId = () => {
  if (typeof window === 'undefined') return ''
  try {
    let sessionId = window.localStorage.getItem(SESSION_KEY)
    if (!sessionId) {
      sessionId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
      window.localStorage.setItem(SESSION_KEY, sessionId)
    }
    return sessionId
  } catch {
    return ''
  }
}

export const logActivity = async ({ eventType, targetType = '', targetId = null, metadata = {} }) => {
  if (!eventType) return null

  const token = getAuthToken()
  if (!token) return null

  const sessionId = ensureSessionId()

  try {
    const response = await api.publicApi.activity.log({
      eventType,
      targetType,
      targetId,
      metadata,
      sessionId
    })

    if (response?.code !== 201) {
      console.warn('Activity logging failed', response)
    }

    return response
  } catch (error) {
    console.error('Activity logging error', error)
    return null
  }
}

const activityTracker = {
  logActivity
}

export default activityTracker

